import type { UUID } from "@/core/types";

export const noteKeys = {
  base: ["note"] as const,
  details: (noteId: UUID) => [...noteKeys.base, noteId, "details"] as const,
  summary: (patientId: UUID) => [...noteKeys.base, patientId, "summary"] as const,
} as const;
